<template>
  <div>
    <!-- 列表页面 -->
    <div class="container">
      <div style="display: flex;flex-direction: row;align-items: center;margin-bottom: 10px;">
        <i class="el-icon-s-fold" ></i>
        <el-breadcrumb separator="/" >
          <el-breadcrumb-item >内容管理</el-breadcrumb-item>
          <el-breadcrumb-item >知识库管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
        <div class="table-content">
          <div class="header-common">
            <div class="header-common-left">
              <div class="title">知识库列表</div>
            </div>
            <header class="header-common-right" v-if="showActionAdd==true">
              <!-- <el-button
                class="right-button-base"
                @click="addKnowledge"
                type="text">
                新增知识库
              </el-button> -->
              <router-link class="right-button-base" :to="{path:'/manage/knowledge/knowledge-add'}">
                新增知识库
              </router-link>
            </header>
          </div>
          <div class="table-list">
            <el-table
              border
              style="width: 100%;"
              :cell-style="tableCellStyle"
              :header-cell-style="tableHeaderCellStyle"
              :max-height="tableHeight"
              v-loading="loading"
              :data="tableData.filter(data => !search || data.createDate.toLowerCase().includes(search.toLowerCase()) || data.authorName.toLowerCase().includes(search.toLowerCase()) || data.typeText.toLowerCase().includes(search.toLowerCase()) || data.filename.toLowerCase().includes(search.toLowerCase()) || data.url.toLowerCase().includes(search.toLowerCase()))"

              >

              <el-table-column
                type="index"
                label="序号">
              </el-table-column>
              <el-table-column
                prop="createDate"
                label="上传日期">
              </el-table-column>
              <el-table-column
                prop="authorName"
                label="上传人员">
              </el-table-column>
              <el-table-column
                prop="typeText"
                label="类型"
                >
              </el-table-column>
              <el-table-column
                prop="filename"
                label="名称">
              </el-table-column>
              <el-table-column
                prop="url"
                label="材料">
                <template slot-scope="scope">
                  <!-- <el-button
                    @click="openDocument(scope.row)"
                    type="text"
                    size="small"
                    style="background-color: #20478D;"
                    class="action-button">
                    查看
                  </el-button> -->
                  <!-- <a :href="scope.row.url" :download="scope.row.filename" target="_blank" style="color: #fff;text-decoration: none;">预览</a> -->
                  <el-link :href="scope.row.url" target="_blank" :underline="false" style="color: #fff;">预览</el-link>
                  <!-- <button @click="downloadData()"></button> -->
                </template>
              </el-table-column>
              <el-table-column
                label="操作">
                <template slot="header" slot-scope="scope">
                  <el-input
                    id="search"
                    v-model="search"
                    size="mini"
                    placeholder="输入关键字搜索"/>
                </template>
                <template slot-scope="scope">
                  <el-button
                    v-if="showActionDelete==true"
                    @click.native.prevent="deleteRow(scope.$index,scope.row)"
                    type="text"
                    size="small"
                    style="background-color: #20478D;"
                    class="action-button">
                    删除
                  </el-button>
                </template>
              </el-table-column>
              </el-table>
          </div>

        </div>
    </div>
  </div>
</template>

<script>
  import {permissionCheckUtil} from '../../../utils/permission.js'

  export default {
    data() {
      return {
        search:'',
        loading:false,
        tableData:[],
        tableHeight:0,

        showActionDelete:false,
        showActionAdd:false
      }
    },
    methods:{
      tableCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);text-align:center;font-size: 14px;font-weight: 400;color: #FEFEFE;margin-right:5px;'
      },
      tableHeaderCellStyle() {
        return 'border-color: rgba(0, 255, 255, 0.22);background:#021950;text-align:center;font-size: 15px;font-weight: 400;color: #00FFFF;margin-right:5px;'
      },
      getData(){
        this.loading = true;
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/knowledge/list';

        this.$http({
          method:'GET',
          url:url,
          headers:headers
        }).then(res=>{
          this.loading = false;
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              if(obj.data.knowledgeList){
                // 获取设备数据
                this.tableData = obj.data.knowledgeList;
                this.handleTypeData()
              }
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }

        }).catch(err=>{
          this.loading = false;
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })

      },
      handleTypeData(){
        var array = this.tableData
        for(var i=0;i<array.length;i++){
          var element = array[i];
          if(element.type == 1){
            element.typeText = '图片'
          }else if(element.type == 2){
            element.typeText = '音视频'
          }else if(element.type == 3){
            element.typeText = '文档'
          }
        }
      },
      // 预览pdf
      // openDocument(row){
      //   window.open(row.url,'_blank')
      // },
      deleteRow(index,row){
        this.$confirm('此操作将永久删除该文件，是否继续？','提示',{
          confirmButtonText:'确定',
          cancelButtonText:'取消',
          type:'warning'
        }).then(() => {
          this.deleteRowAction(index,row.id);
        }).catch(() => {
          this.$message({
            type:'info',
            message:'取消操作'
          })
        })
      },
      deleteRowAction(index,id){
        const headers = {
            'Authorization': localStorage.getItem('token')
        }
        const url = '/knowledge/delete';
        const data = {
          "id":id
        };
        this.$http({
          method:'POST',
          url:url,
          headers:headers,
          data:data
        }).then(res=>{
          if(res.status == 200){//请求成功
          var obj = res.data;
            if(obj.code == 0){
              this.$message.success('删除成功');
              this.tableData.splice(index,1);
            }else{
              this.$message.error(obj.message);
            }
          }else{
            this.$message.error(res.data.message);
          }
        }).catch(err=>{
          if(!err.response){
            this.$message.error(err.message);
          }else{
            this.$message.error(err.response.data.message);
          }
        })
      },
      judgePermissions(){
          let knowledge1 = permissionCheckUtil.findName("knowledge:create");
          let knowledge2 = permissionCheckUtil.findName("knowledge:delete");

          if(knowledge1==true){
            this.showActionAdd = true;
          }
          if(knowledge2==true){
            this.showActionDelete = true;
          }
      },
      sizeFun(){
        this.$nextTick(() => {
          this.tableHeight = window.innerHeight-210 < 300 ? 300 : window.innerHeight-210;
        })
      },
    },
    mounted() {
      window.addEventListener('resize',this.sizeFun)
      this.sizeFun()
      this.getData()
      this.judgePermissions()
    },
    created() {

    },
    beforeDestroy() {
      window.removeEventListener('resize',this.sizeFun)
    }
  }

</script>


<style lang="scss" scoped>
.container {
  margin-top: $header-height;

  .table-content{

    .header-common{
      width: 100%;
      height: 45px;
      border-radius: 12px 12px 0 0 ;
      background: linear-gradient(-90deg, #001940, #1564BE);
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-right: 10px;

      .header-common-left{

        font-size: 20px;

        font-weight: bold;
        color: #FEFEFE;
        margin-left: 21px;

        .title{
          font-size: 20px;
          font-weight: bold;
          color: #FEFEFE;
        }
      }

      .header-common-right{

        .right-button{
          width: 100px;
          height: 40px;
          // line-height: 55px;
          background: #FAFAFA;
          border: 1px solid rgba(0,255,96,0.84);
          border-radius: 20px;
          font-size: 14px;

          font-weight: 400;
          color: #00FFB4;
          margin-right: 20px;
        }

        .right-button-base{
          width: 109px;
          height: 40px;
          border: 1px solid rgba(0,144,255,0.84);
          border-radius: 20px;
          background-color: #20478D;
          font-size: 14px;
          font-weight: 400;
          color: #00DEFF;
          margin-right: 20px;
          display: inline-block;
          line-height: 40px;
          text-align: center;
          text-decoration: none;
        }
      }
    }

    .table-list{

      .hander{
        cursor: pointer;
        color: #fff;
        background-color: #104C90;
        border: 0px;
      }


      .action-button{
        width: 89px;
        height: 31px;
        border: 1px solid rgba(0,144,255,0.84);
        border-radius: 16px;
        font-size: 14px;

        font-weight: 400;
        color: #00DEFF;
        // line-height: 26px;
      }

    }

  }
}
</style>



// WEBPACK FOOTER //
// src/view/manage/knowledge/knowledge-list.vue